import React from "react";

import { useIntl } from "react-intl";

import { Button, ButtonProps } from "@mapmycustomers/ui";

import styles from "./StepControl.module.scss";

interface Props {
  nextButtonProps?: Partial<ButtonProps>;
  nextButtonText?: string;
  onBack?: () => void;
  onNext: () => void;
}

const StepControl: React.FC<Props> = ({ nextButtonProps, nextButtonText, onBack, onNext }) => {
  const intl = useIntl();

  return (
    <div className={styles.bottomContainer}>
      <div>
        {onBack && (
          <Button onClick={onBack}>
            {intl.formatMessage({
              id: "settings.customFields.createEditPane.goBack",
              defaultMessage: "Go Back",
              description: "Settings Custom field - Go Back button",
            })}
          </Button>
        )}
      </div>
      <div>
        <Button onClick={onNext} type="primary" {...nextButtonProps}>
          {nextButtonText ||
            intl.formatMessage({
              id: "settings.customFields.createEditPane.nextStep",
              defaultMessage: "Next Step",
              description: "Settings Custom field - Next Step button",
            })}
        </Button>
      </div>
    </div>
  );
};

export default StepControl;
